import { MessageOrientation } from '../constants/constants';
var StandardTemplateData = /** @class */ (function () {
    function StandardTemplateData(_a) {
        var title = _a.title, lines = _a.lines, buttons = _a.buttons, image = _a.image, _b = _a.orientation, orientation = _b === void 0 ? MessageOrientation.Landscape : _b;
        this._dto = { title: title, lines: lines, buttons: buttons, image: image, orientation: orientation };
    }
    Object.defineProperty(StandardTemplateData.prototype, "title", {
        get: function () {
            return this._dto.title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StandardTemplateData.prototype, "lines", {
        get: function () {
            return this._dto.lines;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StandardTemplateData.prototype, "buttons", {
        get: function () {
            return this._dto.buttons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StandardTemplateData.prototype, "image", {
        get: function () {
            return this._dto.image;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StandardTemplateData.prototype, "orientation", {
        get: function () {
            return this._dto.orientation;
        },
        enumerable: false,
        configurable: true
    });
    StandardTemplateData.prototype.toJSON = function () {
        return {
            title: this.title,
            image: this.image,
            lines: this.lines,
            buttons: this.buttons,
            orientation: this.orientation,
        };
    };
    return StandardTemplateData;
}());
export default StandardTemplateData;
